import HTTP from '@pillarjs/http';
import { Notification, MessageBox } from "@unicloud/element-ui";

const httpInstance = new HTTP({
  baseURL: "/api/aidp/",  //需要本地做反向代理
  timeout: 30000,   //设置超时时间
  responseType: "json",
  withCredentials: true,  //是否允许带cookie
  headers: {
    "Content-Type": "application/json;charset=UTF-8"
  },
});

const install = (Vue) => {
  Object.defineProperty(Vue.prototype, "$http", { value: httpInstance });
}

export const util = httpInstance;

//将axios的实例重新封装成一个plugin，方便 Vue.use(XXX)
export default install;
